import { atom } from "recoil";
import { UserProfileDto } from "../../types/user.types";

export const userDetailsAtom = atom<UserProfileDto | null>({
  key: 'userDetailsAtom',
  default: null,
});